<template>
  <div class="home mt-2">
    <a-row class="mobile-wrapper pl-2 pr-3">
      <a-col class="mobile-full-width mt-4" :span="24" style="margin-top:100px">
        <div>
          <center>
            <img src="@/assets/img/access.png" style="width:100px">
          </center>
        </div>
        <center>
          <h3 class="pt-2">
            Hey,
            <b>{{$auth.user().first_name}}</b>
          </h3>
          <router-view></router-view>
          <div class="mt-2">
            <button class="btn btn-lightgray" @click="goBack">Go Back</button>
          </div>
        </center>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
